import { dotToCommaTransform } from "@/lib/formatters/NumericTextFieldInputCleaner";
import {
  createColumnConfig,
  StandardTableConfigWithGroups,
} from "@stenajs-webui/grid";
import { renderHeadingCenter } from "../lib/customer-table-utils";

export interface ThreeYearsTargetActualTableRow {
  routePairCode: string;
  year: number | undefined;
  target: number | null;
  actual: number | null;
  targetMinus1Year: number | null;
  actualMinus1Year: number | null;
  targetMinus2Year: number | null;
  actualMinus2Year: number | null;
}

export type ThreeYearsTargetActualTableColumn = keyof Omit<
  ThreeYearsTargetActualTableRow,
  "year"
>;

export const threeYearsTargetActualTableConfig = (year: number) => {
  const threeYearsTargetActualTableConfig: StandardTableConfigWithGroups<
    ThreeYearsTargetActualTableRow,
    ThreeYearsTargetActualTableColumn
  > = {
    keyResolver: (item) => `${item.routePairCode}-${item.year}`,
    disableSorting: true,
    columns: {
      routePairCode: createColumnConfig((item) => item.routePairCode, {
        columnLabel: "",
      }),
      target: createColumnConfig(
        (item) => dotToCommaTransform(String(item.target ?? "")),
        {
          columnLabel: "Target",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
          itemLabelFormatter(value) {
            return value ? `${value}%` : "";
          },
        }
      ),
      actual: createColumnConfig(
        (item) => dotToCommaTransform(String(item.actual ?? "")),
        {
          columnLabel: "Actual",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
          itemLabelFormatter(value) {
            return value ? `${value}%` : "";
          },
        }
      ),
      targetMinus1Year: createColumnConfig(
        (item) => dotToCommaTransform(String(item.targetMinus1Year ?? "")),
        {
          columnLabel: "Target",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
          itemLabelFormatter(value) {
            return value ? `${value}%` : "";
          },
        }
      ),
      actualMinus1Year: createColumnConfig(
        (item) => dotToCommaTransform(String(item.actualMinus1Year ?? "")),
        {
          columnLabel: "Actual",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
          itemLabelFormatter(value) {
            return value ? `${value}%` : "";
          },
        }
      ),
      targetMinus2Year: createColumnConfig(
        (item) => dotToCommaTransform(String(item.targetMinus2Year ?? "")),
        {
          columnLabel: "Target",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
          itemLabelFormatter(value) {
            return value ? `${value}%` : "";
          },
        }
      ),
      actualMinus2Year: createColumnConfig(
        (item) => dotToCommaTransform(String(item.actualMinus2Year ?? "")),
        {
          columnLabel: "Actual",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
          itemLabelFormatter(value) {
            return value ? `${value}%` : "";
          },
        }
      ),
    },
    columnGroups: {
      routeCode: {
        label: "",
        columnOrder: ["routePairCode"],
      },
      yearMinus2: {
        render(config) {
          return renderHeadingCenter(config.label);
        },
        label: String(year - 2),
        columnOrder: ["targetMinus2Year", "actualMinus2Year"],
        borderLeft: true,
      },
      yearMinus1: {
        render(config) {
          return renderHeadingCenter(config.label);
        },
        label: String(year - 1),
        columnOrder: ["targetMinus1Year", "actualMinus1Year"],
        borderLeft: true,
      },
      year: {
        render(config) {
          return renderHeadingCenter(config.label);
        },
        label: String(year),
        columnOrder: ["target", "actual"],
        borderLeft: true,
      },
    },
    columnGroupOrder: ["routeCode", "yearMinus2", "yearMinus1", "year"],
  };
  return threeYearsTargetActualTableConfig;
};
